import { ICheckbox } from './type'
import css from './index.module.scss'


/** Checkbox */
export const Checkbox = ({
    id, key, checked, onChange, onClick, isDisabled = false, isPositionAbsolute, left, top, right, bottom
}: ICheckbox) => {

    /** Стили компоненты */
    const componentStyle: React.CSSProperties = {
        position: isPositionAbsolute ? 'absolute' : 'relative',
        left: left,
        top: top,
        right: right,
        bottom: bottom,
    }

    return <>
        <input id={id} key={key} type="checkbox" 
            className={css.input_checkbox} 
            style={componentStyle} 
            disabled={isDisabled} 
            checked={checked} 
            onChange={onChange} 
            onClick={onClick}
        />
    </>
}